import React from "react";
import PropTypes from "prop-types";

import FormRenderer from "Common/Custom/FormRenderer";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const AddEmployeePerformanceForm = ({
  values = {},
  errors = {},
  handleChange,
  handleSubmit,
  loading = false,
  fields = [],
  employees = []
}) => {

  const statusOptions = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" }
  ];

  const optionConfig = {
    employee_id: {
      list: employees,
      valueKey: "employee_id",
      labelKey: "full_name"
    },
    status: {
      list: statusOptions,
      valueKey: "value",
      labelKey: "label"
    }
  };

  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Add Employee Performance</HeadingOne>}
    >
      <FormRenderer
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        optionConfig={optionConfig}
      />

      <FormSubmitButton
        label="Save"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddEmployeePerformanceForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  fields: PropTypes.array.isRequired,
  employees: PropTypes.array.isRequired,
};

export default AddEmployeePerformanceForm;